module.exports = __webpack_public_path__ + "static/media/KrankKeinTrainng.be52e6ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/KrankKeinTrainng.jpg
// module id = 332
// module chunks = 0